module.exports = __webpack_public_path__ + "media/images/apple-touch-icons/apple-touch-icon-72x72-1fe20992b030fc7ee6b2ccdb98a5394e.png";